/* eslint-disable global-require,import/no-unresolved,react/destructuring-assignment,react/prop-types */
import React, { Component } from 'react'
import { ScrollView, Text, View } from 'react-native'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import styles, { colors } from '../../styles'
import DeviceModels from '../DeviceModels'
import SimpleMenuListItem from '../subcomponents/SimpleMenuListItem'
import * as tapEvents from '../../actions/tapEvents'
import { getCountryCodeFromLocale, getLanguageCodeFromLocale, log } from '../../utils'
import * as RegionalContentLookup from '../methods/RegionalContentLookUp'
import listMenuItemStyles from '../../styles/listMenuItem'

const CRTD_PRECAUTION_EXCLUDED_COUNTRIES = ['BE']
const CRTP_PRECAUTION_EXCLUDED_COUNTRIES = ['IT', 'ES', 'PT', 'NL', 'BE']
const CRTP_PRECAUTION_EXCLUDED_LANGUAGES = ['nl']
const ICD_PRECAUTION_EXCLUDED_COUNTRIES = ['BE']
// const PACEMAKER_PRECAUTION_EXCLUDED_COUNTRIES = []

class FAQDeviceSystemPage extends Component {
  getModelType() {
    const { currentModelNumber } = this.props
    return currentModelNumber && DeviceModels[currentModelNumber] ? DeviceModels[currentModelNumber].type : null
  }

  tapFAQItem = async (title, id) => {
    this.props.faqItemTapped(title, id)
  }

  render() {
    const { t } = this.props
    return (
      <View accessibilityLabel={t('access:faqDeviceSystemList')} testID="view-FAQListPage" style={[styles.container, { backgroundColor: colors.raven_grey10 }]}>
        <ScrollView
          testID="scrollview-FAQDevicePage"
        >
          <View style={{
            flex: 1, flexDirection: 'column', alignItems: 'center',
          }}
          >
            <Text style={listMenuItemStyles.sectionTextHeader}>
              {t('yourImplantedDevice')}
            </Text>
          </View>
          {this.getDeviceSpecificCells()}
          <View style={styles.lightSeparator} />
          <SimpleMenuListItem
            t={t}
            titleKey="faq:howBatteryWork"
            testID="faqbtn-battery"
            onPress={() => this.tapFAQItem('howBatteryWork', 'battery')}
          />
          {this.getPrecautionFAQ()}
        </ScrollView>
      </View>
    )
  }

  getPrecautionFAQ() {
    const { t, locale } = this.props
    const modelType = this.getModelType()
    log(`modelType: ${modelType}`)
    if (modelType === 'ICD' && !ICD_PRECAUTION_EXCLUDED_COUNTRIES.includes(getCountryCodeFromLocale(locale))) {
      return (
        <>
          <View style={styles.lightSeparator} />
          <SimpleMenuListItem
            t={t}
            titleKey="icdPrecautionsTitle"
            testID="faqbtn-icd-precautions"
            onPress={() => this.tapFAQItem('icdPrecautionsTitle', 'icdPrecautions')}
          />
        </>
      )
    }
    if (modelType === 'CRT-D' && !CRTD_PRECAUTION_EXCLUDED_COUNTRIES.includes(getCountryCodeFromLocale(locale))
      && !CRTP_PRECAUTION_EXCLUDED_LANGUAGES.includes(getLanguageCodeFromLocale(locale))) {
      return (
        <>
          <View style={styles.lightSeparator} />
          <SimpleMenuListItem
            t={t}
            titleKey="crtPrecautionsTitle"
            testID="faqbtn-crt-d-precautions"
            onPress={() => this.tapFAQItem('crtPrecautionsTitle.D', 'crtdPrecautions')}
          />
        </>
      )
    }
    if (modelType === 'CRT-P' && !CRTP_PRECAUTION_EXCLUDED_COUNTRIES.includes(getCountryCodeFromLocale(locale))) {
      return (
        <>
          <View style={styles.lightSeparator} />
          <SimpleMenuListItem
            t={t}
            titleKey="crtPrecautionsTitle"
            testID="faqbtn-crt-p-precautions"
            onPress={() => this.tapFAQItem('crtPrecautionsTitle.P', 'crtpPrecautions')}
          />
        </>
      )
    }
    if (modelType === 'Pacemaker') { // && !PACEMAKER_PRECAUTION_EXCLUDED_COUNTRIES.includes(getCountryCodeFromLocale(locale))) {
      return (
        <>
          <View style={styles.lightSeparator} />
          <SimpleMenuListItem
            t={t}
            titleKey="pacemakerPrecautionsTitle"
            testID="faqbtn-pacemaker-precautions"
            onPress={() => this.tapFAQItem('pacemakerPrecautionsTitle', 'pacemakerPrecautions')}
          />
        </>
      )
    }
    return null
  }

  getDeviceSpecificCells() {
    const { t } = this.props
    const modelType = this.getModelType()
    switch (modelType) {
      case 'ICD': {
        return (
          <SimpleMenuListItem t={t} titleKey="faq:faqICD" testID="faqbtn-icd" onPress={() => this.tapFAQItem('faqICD', 'icd')} />
        )
      }
      case 'S-ICD': {
        return (
          <SimpleMenuListItem t={t} titleKey="faq:whatIsSICD" testID="faqbtn-sicd" onPress={() => this.tapFAQItem('whatIsSICD', 'sicd')} />
        )
      }
      case 'Pacemaker': {
        return (
          <SimpleMenuListItem t={t} titleKey="faq:whatIsPacemaker" testID="faqbtn-pacemaker" onPress={() => this.tapFAQItem('whatIsPacemaker', 'pacemaker')} />
        )
      }
      default:
        return null
    }
  }
}

FAQDeviceSystemPage.propTypes = {
  faqItemTapped: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  currentModelNumber: PropTypes.string,
}

FAQDeviceSystemPage.defaultProps = {
  currentModelNumber: null,
}

const actionCreators = {
  faqItemTapped: tapEvents.faqItemTapped,
  regionalContentLookup: RegionalContentLookup.regionalContentLookup,
}

const mapStateToProps = (state) => {
  const { storedData } = state
  return {
    locale: storedData.locale,
    currentModelNumber: storedData.deviceModel,
    monitoringStatus: storedData.monitoringStatus,
    dateOfBirth: storedData.dateOfBirth,
  }
}

export const FAQDeviceSystemPageComponent = FAQDeviceSystemPage

export default withTranslation(['faq', 'common'])(connect(mapStateToProps, actionCreators)(FAQDeviceSystemPage))
